import { Injectable } from '@angular/core';

import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    constructor(
        private _utilService: UtilsService
    ) { }

    getItem(key) {
        let userData;
        if (window.localStorage.getItem('rememberMe') == 'true') {
            userData = JSON.parse(window.localStorage.getItem(key));
        }
        else {
            userData = JSON.parse(window.sessionStorage.getItem(key));
        }
        return userData
    }

    setItem(key, value) {
        window.localStorage[key] = JSON.stringify(value);
        return this.getItem(key);
    }

    removeItem(key) {
        window.localStorage.removeItem(key);
    }

    clearAll() {
        window.localStorage.clear();
    }
}